import styled from '@emotion/styled/macro';
import { css } from '@emotion/react';
import { colors, fonts, leading } from '../../styles/theme';

import { Icon } from '../../ui_elements/icons';

const IconStyle = css`
  ${Icon} {
    color: ${colors.blue.primary};
    display: inline;
    &:hover {
      color: ${colors.blue.primaryDark};
      cursor: pointer;
    }
    &::before {
      font-size: ${fonts.sans.size.normal};
      vertical-align: middle;
      margin-left: 10px;
    }
  }
`;

export const Header = styled('header')`
  margin-bottom: 33px;
`;

export const H1 = styled('h1')`
  color: ${colors.orange.primary};
  font-size: 40px;
  font-weight: ${fonts.sans.weight.light};
  letter-spacing: -0.05em;
  line-height: 1;
  margin-top: 0;
  margin-bottom: ${leading.half};
  ${IconStyle};
`;

export const H2 = styled('h2')`
  color: ${colors.black};
  font-size: 26px;
  font-weight: ${fonts.sans.weight.bold};
  letter-spacing: -0.01em;
  line-height: 1.2;
  margin-bottom: ${leading.half};
  margin-top: 0;
  ${IconStyle}
`;

export const H3 = styled('h3')`
  color: ${colors.grey.primary};
  font-size: 22px;
  font-weight: ${fonts.sans.weight.light};
  line-height: 1.35;
  margin-bottom: ${leading.third};
  margin-top: 0;
  ${IconStyle}
`;

export const H4 = styled('h4')`
  font-size: 18px;
  font-weight: ${fonts.sans.weight.bold};
  line-height: 1.4;
  margin-bottom: ${leading.fourth};
  margin-top: 0;
  ${IconStyle}
`;

export const H5 = styled('h5')`
  font-size: 15px;
  font-weight: ${fonts.sans.weight.bold};
  margin-top: 0;
  margin-bottom: 0;
`;

export const Subtext = styled('span')`
  font-size: ${fonts.sans.size.small};
  color: ${colors.grey.primary};
`;

const requiredStyles = css`
  &:after {
    content: ' *';
    font-size: 20px;
    line-height: inherit;
    position: relative;
    top: 5px;
    color: ${colors.red.primary};
  }
`;

const labelStyles = css`
  color: ${colors.grey.primary};
  font-size: 13px;
  line-height: 16px;
  text-transform: uppercase;
  letter-spacing: 0.01em;
  margin: 0;
  & + div,
  > div,
  & + input,
  > input,
  & + textarea,
  > textarea {
    margin-top: 4px;
  }
  + ${Subtext} {
    display: block;
    margin-bottom: ${leading.fourth};
  }
`;

export const H6 = styled('h6')`
  ${labelStyles};
  ${(props) => (props.required ? requiredStyles : '')};
  font-weight: 500;
`;

export const Label = styled('label')`
  display: block;
  ${labelStyles};
  ${(props) => (props.required ? requiredStyles : '')};
  &:hover {
    cursor: pointer;
  }
`;

export const P = styled('p')`
  color: ${colors.black};
  margin-top: 0;
  margin-bottom: ${leading.half};
  &:first-of-type {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ExtraSmall = styled('span')`
  font-size: ${fonts.sans.size.xsmall};
`;

export const Small = styled('span')`
  font-size: ${fonts.sans.size.small};
`;

export const Normal = styled('span')`
  font-size: ${fonts.sans.size.normal};
`;

export const Large = styled('span')`
  font-size: ${fonts.sans.size.large};
`;

export const ExtraLarge = styled('span')`
  font-size: ${fonts.sans.size.xlarge};
`;

export const ExtraExtraLarge = styled('span')`
  font-size: ${fonts.sans.size.xxlarge};
`;

export const List = styled('ul')`
  margin: 0;
  padding: 0 0 0 20px;
  list-style: none;
`;

export const ListItem = styled('li')``;

export const OrderedList = styled('ol')`
  margin: 0;
  padding: 0 0 0 30px;
`;
